//
// # useIvaResults Hook
//
// Watches for IVA results from the workspace state.
// Results are stored when the run-iva tool completes.
//

import { useEffect, useState } from "react";
import { useWorkspace, useWorkspaceSnapshot } from "../../context";
import type { IvaResult } from "./types";

interface IvaResultsState {
  result: IvaResult | null;
  loading: boolean;
}

export function useIvaResults(): IvaResultsState {
  const workspace = useWorkspace();
  const snapshot = useWorkspaceSnapshot();

  const [state, setState] = useState<IvaResultsState>({
    result: null,
    loading: false,
  });

  useEffect(() => {
    const ivaResult = workspace.getIvaResult();
    if (ivaResult) {
      setState({ result: ivaResult, loading: false });
    }
  }, [workspace, snapshot.contentVersion]);

  return state;
}
